var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 5.625C37.4333 5.625 38.4084 6.02009 39.1272 6.72335C39.8461 7.42661 40.25 8.38044 40.25 9.375V35.625C40.25 36.6196 39.8461 37.5734 39.1272 38.2766C38.4084 38.9799 37.4333 39.375 36.4167 39.375H9.58333C8.56667 39.375 7.59165 38.9799 6.87276 38.2766C6.15387 37.5734 5.75 36.6196 5.75 35.625V9.375C5.75 8.38044 6.15387 7.42661 6.87276 6.72335C7.59165 6.02009 8.56667 5.625 9.58333 5.625H36.4167ZM35.4583 34.6875V24.75C35.4583 23.1289 34.8 21.5741 33.6282 20.4278C32.4564 19.2815 30.8672 18.6375 29.21 18.6375C27.5808 18.6375 25.6833 19.6125 24.7633 21.075V18.9938H19.4158V34.6875H24.7633V25.4437C24.7633 24 25.9517 22.8188 27.4275 22.8188C28.1392 22.8188 28.8217 23.0953 29.3249 23.5876C29.8281 24.0799 30.1108 24.7476 30.1108 25.4437V34.6875H35.4583ZM13.1867 16.05C14.0407 16.05 14.8597 15.7181 15.4636 15.1274C16.0674 14.5366 16.4067 13.7354 16.4067 12.9C16.4067 11.1562 14.9692 9.73125 13.1867 9.73125C12.3276 9.73125 11.5037 10.0651 10.8962 10.6594C10.2888 11.2536 9.9475 12.0596 9.9475 12.9C9.9475 14.6438 11.4042 16.05 13.1867 16.05ZM15.8508 34.6875V18.9938H10.5417V34.6875H15.8508Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f2e0d26f8d91bc9790878937a703bef6.svg";
export { ForwardRef as ReactComponent };